class NewsletterSignup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Get the form and response message elements
      const form = this.querySelector('form');
      const responseMessage = this.querySelector('.response-message');
      const emailInput = form.querySelector('input[name="email"]');

      emailInput.addEventListener('focus', () => {
        responseMessage.textContent = ''; // Clear the message
        form.classList.remove('success', 'error'); // Remove all classes
      });

      // Add submit event listener to the form
      form.addEventListener('submit', (event) => {
        console.log('submit');

        event.preventDefault();

        console.log('prevented');

        const email = emailInput.value;

        // Validate email
        if (!email || !email.includes('@')) {
          responseMessage.textContent = 'Please enter a valid email address.';
          return;
        }

        // Klaviyo API details
        const klaviyoPublicApiKey = this.getAttribute('data-public-api-key');
        const klaviyoListId = this.getAttribute('data-list-id');

        // Klaviyo API endpoint
        const klaviyoUrl = `https://a.klaviyo.com/client/subscriptions?company_id=UNnBfT`;

        // Prepare the request payload
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'newsletter signup footer',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: klaviyoListId,
                },
              },
            },
          },
        };

        // Send AJAX request to Klaviyo
        fetch(klaviyoUrl, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-01-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(payload),
        })
        .then(response => {
            if (response.ok) {
              const contentType = response.headers.get('content-type');
              if (contentType && contentType.includes('application/json')) {
                return response.json();
              } else {
                return null;
              }
            } else {
              // Handle specific status codes
              if (response.status === 400) {
                throw new Error('Error. Please try again.');
              } else if (response.status === 500) {
                throw new Error('Error. Please try again.');
              } else {
                throw new Error(`Server responded with status: ${response.status}`);
              }
            }
          })
          .then(data => {
            if (data) {
              console.log('Response data:', data);
            }
            responseMessage.textContent = 'Thank you for subscribing';
            form.classList.remove('error');
            form.classList.add('success');
            form.reset();
          })
          .catch(error => {
            console.error('Error:', error);
            responseMessage.textContent = error.message; // Display the error message to the user
            form.classList.remove('success');
            form.classList.add('error');
          });
      });
    }
  }

  // Define the custom element
  customElements.define('newsletter-signup', NewsletterSignup);